import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';

const infantSeatingInfo = css`
  font-size: ${tokens.fontSize.paragraph['paragraph-2']};
  margin: 0;
`;
export const InfantSeatingNotice = () => (
  <p css={infantSeatingInfo}>
    <>
      {t('traveler.infant.seatingInfo', {
        defaultValue: 'This infant will be seated with the traveler above',
      })}
    </>
  </p>
);
